import { render, staticRenderFns } from "./RepoInsurance.vue?vue&type=template&id=6757973e&"
import script from "./RepoInsurance.vue?vue&type=script&lang=js&"
export * from "./RepoInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports